import { AfterContentChecked, Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SvgMatType } from 'src/app/constants/icons';
import { TableColumnType } from 'src/app/constants/table';
import { Contact } from 'src/app/models/contacts';

import { TableColumn } from 'src/app/models/table';
import { HelperService } from 'src/app/services/helper.service';

@Component({
    selector: 'mwp-card-contact',
    templateUrl: './card-contact.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CardContactComponent implements OnInit, AfterContentChecked {
    @Input() public header: string;
    @Input() public contacts: Contact[];

    public currentContacts: Contact[];
    public tableData: MatTableDataSource<Contact>;
    public tableColumns: TableColumn[] = [
        {
            columnName: 'Name',
            propertyId: 'name',
            columnType: TableColumnType.label,
            width: '30%'
        },
        {
            columnName: 'Contact #',
            propertyId: 'workPhone',
            columnType: TableColumnType.label,
            width: '15%'
        },
        {
            columnName: 'Note',
            propertyId: 'note',
            columnType: TableColumnType.label,
            width: '25%'
        },
        {
            columnName: 'External Link',
            propertyId: 'externalLink',
            columnType: TableColumnType.hyperLink,
            dataTypePropertyId: 'externalLinkName',
            svgCustomName: SvgMatType.ExternalLink,
            isNewTab: true,
            width: '30%'
        },
    ];

    constructor(
        private helperService: HelperService,
    ) {

    }

    ngOnInit(): void {
        this.loadGid();
    }

    ngAfterContentChecked(): void {
        if (this.contacts != this.currentContacts) {
            this.loadGid();
        }
    }

    private loadGid() {
        this.currentContacts = this.contacts;

        this.tableData = new MatTableDataSource<Contact>();
        this.tableData.data = this.currentContacts;
    }

    public openTab(url: string): void {
        window.open(url, "_blank");
    }
}